import * as R from 'ramda'
import createSelector from 'utils/redux/createSelector' // import { createSelector } from 'reselect'
import { properties, tenants, repairmen, agents, managers, owners } from './entities'

export let propertiesData = createSelector([properties], R.pipe(R.values, R.map(x => ({id: x._id, display: x.alias}))))
export let tenantsData = createSelector([tenants], R.pipe(R.values, R.map(x => ({id: x._id, display: (x.firstName + ' ' + x.lastName)}))))
export let repairmenData = createSelector([repairmen], R.pipe(R.values, R.map(x => ({id: x._id, display: x.firstName}))))
export let agentsData = createSelector([agents], R.pipe(R.values, R.map(x => ({id: x._id, display: x.firstName}))))
export let managersData = createSelector([managers], R.pipe(R.values, R.filter(x => !x.inactive), R.map(x => ({id: x._id, display: x.name}))))
export let ownersData = createSelector([owners], R.pipe(R.values, R.map(x => ({id: x._id, display: x.firstName}))))



// WEBPACK FOOTER //
// ./src/selectors/mentions.js